import React, {useEffect, useState} from "react";
import {makeStyles, createStyles} from "@mui/styles";

import List from "@mui/material/List";
import HardwareTwoToneIcon from "@mui/icons-material/HardwareTwoTone";
import IconDashboard from "@mui/icons-material/Dashboard";
import IconShoppingCart from "@mui/icons-material/ShoppingCart";
import IconPeople from "@mui/icons-material/People";
import IconBarChart from "@mui/icons-material/BarChart";
import IconLibraryBooks from "@mui/icons-material/LibraryBooks";
import AppMenuItem from "./AppMenuItem";
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import Employee from "layouts/EmployeeUpdate";
import Appraisal_Form from "layouts/Appraisal_Form";
import ViewRatings from "layouts/ViewRatings";
import Resignation from "layouts/Resignation";
import PolicyDocuments from "layouts/PolicyDocuments";
import EmployeeReferralBonusDocument from "layouts/EmployeeReferralBonusdocument";
import LMSPolicyDocument from "layouts/LeaveManagement/LMSPolicyDocuments";
import ApplyLeave from "layouts/LeaveManagement/ApplyLeave";
import LeaveRequestList from "layouts/LeaveManagement/LeaveRequestList";
import GenerateCompensatoryOff from "layouts/LeaveManagement/GenerateCompensatoryOff";
import ApplyMaternityLeaves from "layouts/LeaveManagement/ApplyMaternityLeaves";
import ListCompensatoryOff from "layouts/LeaveManagement/ListCompensatoryOff";
import Gallery from "layouts/Gallery";
import ChangePassword from "layouts/Admin/Employee/ChangePassword";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
//   React context
import {useMaterialUIController} from "context";
import {collapseItem} from "examples/Sidenav/styles/sidenavCollapse";
import LMSPolicyDocuments from "layouts/LeaveManagement/LMSPolicyDocuments";
import PropTypes from "prop-types";
import {Icon} from "@mui/material";
import Logout from "./Logout";
import Add_technical_skills from "layouts/Appraisal_Form/Add_technical_skills";
import List_technical_skills from "layouts/Appraisal_Form/List_technical_skills";
import KRA_form_overview from "layouts/Appraisal_Form/KRA_form_overview";
import KRA_status from "layouts/Appraisal_Form/KRA_Status";

import Probation_List from "layouts/Probation_Period/Probation_List";
import Resignation_Request_List from "layouts/Resignation Request/Resignation_Request_List";
import ExperienceReport from "layouts/Admin/Reports/ExperienceReport";
import CompensatoryRequestReceived from "layouts/LeaveManagement/CompensatoryRequestReceived";
import LeaveApplicationReceived from "layouts/LeaveManagement/LeaveApplicationReceived";

import EmployeeList from "layouts/Admin/Employee/EmployeeList";
import CreateNewOffer from "layouts/Admin/OfferLetter/CreateNewOffer";
import OfferList from "layouts/Admin/OfferLetter/OfferList";
import AppointmentList from "layouts/Admin/AppointmentLetter/AppointmentList";
import ProbationList from "layouts/Admin/ProbationPeriod/ProbationList";
import PerformanceImprovementList from "layouts/Admin/PerformanceImprovement/PerformanceImprovementList";
import OpenKRAWindow from "layouts/Admin/PerformanceAppraisal/OpenKRAWindow";
import KraFormOverview from "layouts/Admin/PerformanceAppraisal/KraFormOverview";
import AddSkills from "layouts/Admin/PerformanceAppraisal/AddSkills";
import ListSkills from "layouts/Admin/PerformanceAppraisal/ListSkills";
import StatusReport from "layouts/Admin/PerformanceAppraisal/StatusReport";
import ExtendKra from "layouts/Admin/PerformanceAppraisal/ExtendKra";
import AdminApplyLeave from "layouts/Admin/LeaveManagement/AdminApplyLeave";
import AdminLeaveRequest from "layouts/Admin/LeaveManagement/AdminLeaveRequest";
import AssignCompensatoryOff from "layouts/Admin/LeaveManagement/AssignCompensatoryOff";
import AdminListCompensatoryOff from "layouts/Admin/LeaveManagement/AdminListCompensatoryOff";
import ResignationRequestList from "layouts/Admin/ResignationRequest/ResignationRequestList";
import Performance_Improvement_List from "layouts/Appraisal_Form/Performance_Improvement_List";
import CreatePerformanceImprovement from "layouts/Admin/PerformanceImprovement/CreatePerformanceImprovement";
import AddProject from "layouts/Admin/Project/AddProject";
import ProjectList from "layouts/Admin/Project/ProjectList";
import EmployeeRosterReport from "layouts/Admin/Reports/EmployeeRosterReport";
import EmployeeAttendanceeReport from "layouts/Admin/Reports/EmployeeAttendanceeReport";
import Temp_biom_dataReport from "layouts/Admin/Reports/Temp_biom_dataReport";
import DefaulterList from "layouts/Admin/Reports/DefaulterList";
import ProjectReport from "layouts/Admin/Reports/ProjectReport";
import TechnologyReport from "layouts/Admin/Reports/TechnologyReport";
import BiometricLeaveReport from "layouts/Admin/Reports/BiometricLeaveReport";
import LWPLeaveReport from "layouts/Admin/Reports/LWPLeaveReport";
import ConsumedLeaveReport from "layouts/Admin/Reports/ConsumedLeaveReport";
import BalanceLeaveReport from "layouts/Admin/Reports/BalanceLeaveReport";
import ReportingList from "layouts/Admin/Reports/ReportingList";
import PerformanceAppraisalReport from "layouts/Admin/Reports/PerformanceAppraisalReport";
import AdminProbationReport from "layouts/Admin/Reports/AdminProbationReport";
import AdminJoiningReport from "layouts/Admin/Reports/AdminJoiningReport";
import AddJobVacancy from "layouts/Admin/JobVacancy/AddJobVacancy";
import JobVacancyList from "layouts/Admin/JobVacancy/JobVacancyList";
import AddYoutubeLinks from "layouts/Admin/YoutubeLinks/AddYoutubeLinks";
import YoutubeLinksList from "layouts/Admin/YoutubeLinks/YoutubeLinksList";
import EmployeeBillingReport from "layouts/Admin/Reports/EmployeeBillingReport";
import VoucherWindow from "layouts/Admin/DiwaliVoucher/VoucherWindow";
import UploadVouchers from "layouts/Admin/DiwaliVoucher/UploadVouchers";
import CronJobLinks from "layouts/Admin/Setting/CronJobLinks";
import SetPermissions from "layouts/Admin/Setting/SetPermissions";
import AdminPermissions from "layouts/Admin/Setting/AdminPermissions";
import Event from "layouts/Admin/Setting/Event";
import BiometricFileUpload from "layouts/Admin/Setting/BiometricFileUpload";
import BirthdayTemplateUpload from "layouts/Admin/Setting/BirthdayTemplateUpload";
import ProcessAttendanceData from "layouts/Admin/Setting/ProcessAttendanceData";
import DefaultValues from "layouts/Admin/Setting/DefaultValues";
import Experience_Reports from "layouts/Reports/Experience_Reports";
import ProtectedRoute from "ProtectedRoute";
import ClientList from "layouts/Admin/Project/ClientList";
import AddClient from "layouts/Admin/Project/AddClient";
import EmployeeProbationList from "layouts/Probation_Period/Probation_List";
import DescriptionIcon from "@mui/icons-material/Description";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BarChartIcon from "@mui/icons-material/BarChart";
import WorkIcon from "@mui/icons-material/Work";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

import FolderSharedIcon from "@mui/icons-material/FolderShared";

import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import SettingsIcon from "@mui/icons-material/Settings";
import ImageIcon from "@mui/icons-material/Image";

import LogoutIcon from "@mui/icons-material/Logout";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AdminChangePassword from "layouts/Admin/Employee/AdminChangePassword";
import ChangeEmployeePassword from "layouts/EmployeePassword/ChangeEmployeePassword";
import AddComponent from "layouts/IT_Dept/AssetManagement/AddComponent";
import AddAsset from "layouts/IT_Dept/AssetManagement/AddAsset";
import IssueAsset from "layouts/IT_Dept/AssetManagement/IssueAsset";
import ReceiveAsset from "layouts/IT_Dept/AssetManagement/ReceiveAsset";
import AssetList from "layouts/IT_Dept/AssetManagement/AssetList";
import EmployeeAssetsHistory from "layouts/EmployeeAssetsHistory";
import ITHelpdesk from "layouts/IT_Dept/Helpdesk/ITHelpdesk";

import ExitClearanceForm from "layouts/exitClearance/ExitClearanceForm";
import ITClearanceList from "layouts/exitClearance/ITClearance/ITClearanceList";
import FinanceClearanceList from "layouts/exitClearance/finance/FinanceClearanceList";
import AdministrationClearanceList from "layouts/exitClearance/adminstration/AdministrationClearanceList";
import HRClearanceList from "layouts/exitClearance/hrClearance/HRClearanceList";
import ExitInterviewList from "layouts/exitClearance/hrClearance/ExitInterviewList";
import AssignKRA from "layouts/Appraisal_Form/AssignKRA";
import KRAList from "layouts/Appraisal_Form/KRAList";

// let Login_routes = localStorage.getItem("login_response");
let appMenuItems;

const AppMenu = ({item, collapse, icon, name, key, active, link, ...rest}) => {
  const [login_response, setLogin_response] = useState([]);
  const [openItem, setOpenItem] = useState(null);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("login_response"));
    if (data && data.data) {
      setLogin_response(data.data.jsonData);
      console.log("data.jsonData", data.data.jsonData);
    }
  }, []);

  const shouldShowExitClearance = () => {
    const resignationApprovedStatus = parseInt(
      window.sessionStorage.getItem("resignationApprovedStatus") ||
        localStorage.getItem("resignationApprovedStatus") ||
        "0"
    );

    const resignationEndDate =
      window.sessionStorage.getItem("resignationEndDate") ||
      localStorage.getItem("resignationEndDate") ||
      "";

    // Check if resignation is approved
    if (resignationApprovedStatus !== 1 || !resignationEndDate) {
      return false;
    }

    // Check if end date is not in the past
    const endDate = new Date(resignationEndDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to compare only dates
    endDate.setHours(0, 0, 0, 0);

    return endDate >= today;
  };
  // let nested_routes = login_response?login_response.jsonData:"";
  // console.log("login_response_in",login_response);
  let modifiedArray;
  // let Item = null;
  if (login_response) {
    console.log("login_response", login_response);
    if (JSON.parse(localStorage.getItem("userType")) == "Employee") {
      const exitClearanceItem = shouldShowExitClearance()
        ? [
            {
              name: "Exit ClearanceForm",
              link: "/exitClearanceForm",
              component: (
                <ProtectedRoute>
                  <ExitClearanceForm />
                </ProtectedRoute>
              )
            }
          ]
        : [];
      appMenuItems = [
        {
          name: "Dashboard",
          link: "/dashboard",
          Icon: IconDashboard,
          component: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )
        },
        {
          name: "Employee",
          Icon: IconPeople,
          items: [
            {
              name: "View Details",
              link: "/profile",
              component: (
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              )
            },
            {
              name: "Update",
              link: "/employee",
              component: (
                <ProtectedRoute>
                  <Employee />
                </ProtectedRoute>
              )
            },
            {
              name: "Appraisal Form",
              link: "/evaluationpolicy",
              component: (
                <ProtectedRoute>
                  <Appraisal_Form />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "View Ratings",
            //   link: "/viewRatings",
            //   component: <ViewRatings />
            // },
            {
              name: "Resignation",
              link: "/resignation",
              component: (
                <ProtectedRoute>
                  <Resignation />
                </ProtectedRoute>
              )
            },
            // ...exitClearanceItem,
            {
              name: "Policy Documents",
              link: "/policyDocuments",
              component: (
                <ProtectedRoute>
                  <PolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Referral Bonus",
              link: "/employeeReferralBonusDocument",
              component: (
                <ProtectedRoute>
                  <EmployeeReferralBonusDocument />
                </ProtectedRoute>
              )
            },
            {
              name: "Assets History",
              link: "/employeeAssetsHistory",
              component: (
                <ProtectedRoute>
                  <EmployeeAssetsHistory />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Leave Management",
          Icon: WorkOffIcon,
          items: [
            {
              name: "LMS Policy Document",
              link: "/lMSPolicyDocument",
              component: (
                <ProtectedRoute>
                  <LMSPolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply for Leave",
              link: "/applyLeave",
              component: (
                <ProtectedRoute>
                  <ApplyLeave />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Request List",
              link: "/leaveRequestList",
              component: (
                <ProtectedRoute>
                  <LeaveRequestList />
                </ProtectedRoute>
              )
            },
            // ,
            // {
            //   name: "View Ratings",
            //   link: "/viewRatings",
            //   component: <ProtectedRoute><ViewRatings /></ProtectedRoute>,
            // }
            {
              name: "Generate Compensatory Off",
              link: "/generateCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <GenerateCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply Maternity Leaves",
              link: "/applyMaternityLeaves",
              component: (
                <ProtectedRoute>
                  <ApplyMaternityLeaves />
                </ProtectedRoute>
              )
            },
            {
              name: "List Compensatory Off",
              link: "/listCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <ListCompensatoryOff />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Gallery",
          link: "/gallery",
          Icon: ImageIcon,
          component: (
            <ProtectedRoute>
              <Gallery />
            </ProtectedRoute>
          )
        },
        {
          name: "Settings",
          Icon: SettingsIcon,
          items: [
            {
              name: "Change Password",
              link: "/changeEmployeePassword",
              component: (
                <ProtectedRoute>
                  <ChangeEmployeePassword />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Logout",
          link: "/logout",
          Icon: LogoutIcon,
          component: (
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          )
        }
      ];
    } else if (
      JSON.parse(localStorage.getItem("userType")) == "Manager" ||
      JSON.parse(localStorage.getItem("userType")) == "Finance_Manager"
    ) {
      appMenuItems = [
        {
          name: "Dashboard",
          link: "/dashboard",
          Icon: IconDashboard,
          component: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )
        },

        {
          name: "Employee",
          Icon: IconPeople,
          items: [
            {
              name: "View Details",
              link: "/profile",
              component: (
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              )
            },
            {
              name: "Update",
              link: "/employee",
              component: (
                <ProtectedRoute>
                  <Employee />
                </ProtectedRoute>
              )
            },
            {
              name: "Appraisal Form",
              link: "/evaluationpolicy",
              component: (
                <ProtectedRoute>
                  <Appraisal_Form />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "View Ratings",
            //   link: "/viewRatings",
            //   component: (
            //     <ProtectedRoute>
            //       <ViewRatings />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "Resignation",
              link: "/resignation",
              component: (
                <ProtectedRoute>
                  <Resignation />
                </ProtectedRoute>
              )
            },
            {
              name: "Policy Documents",
              link: "/policyDocuments",
              component: (
                <ProtectedRoute>
                  <PolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Referral Bonus",
              link: "/employeeReferralBonusDocument",
              component: (
                <ProtectedRoute>
                  <EmployeeReferralBonusDocument />
                </ProtectedRoute>
              )
            },
            {
              name: "Assets History",
              link: "/employeeAssetsHistory",
              component: (
                <ProtectedRoute>
                  <EmployeeAssetsHistory />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Performance Appraisal",
          Icon: BarChartIcon,
          items: [
            {
              name: "Add Technical Skills",
              link: "/add_technical_skills",
              component: (
                <ProtectedRoute>
                  <Add_technical_skills />
                </ProtectedRoute>
              )
            },
            {
              name: "List Technical Skills",
              link: "/list_technical_skills",
              component: (
                <ProtectedRoute>
                  <List_technical_skills />
                </ProtectedRoute>
              )
            },
            {
              name: "Assign KRA",
              link: "/manager/appraisal/assign",
              component: (
                <ProtectedRoute>
                  <AssignKRA />
                </ProtectedRoute>
              )
            },
            {
              name: "KRA List",
              link: "/manager/appraisal/kraList",
              component: (
                <ProtectedRoute>
                  <KRAList />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "KRA Form Overview",
            //   link: "/kra_form_overview",
            //   component: (
            //     <ProtectedRoute>
            //       <KRA_form_overview />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "KRA Status",
              link: "/kra_status",
              component: (
                <ProtectedRoute>
                  <KRA_status />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Performance Improvement",
          Icon: TrendingUpIcon,
          items: [
            {
              name: "List",
              link: "/performanceImprovementList",
              component: (
                <ProtectedRoute>
                  <PerformanceImprovementList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Leave Management",
          Icon: WorkOffIcon,
          items: [
            {
              name: "LMS Policy Document",
              link: "/lMSPolicyDocument",
              component: (
                <ProtectedRoute>
                  <LMSPolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply for Leave",
              link: "/applyLeave",
              component: (
                <ProtectedRoute>
                  <ApplyLeave />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Request List",
              link: "/leaveRequestList",
              component: (
                <ProtectedRoute>
                  <LeaveRequestList />
                </ProtectedRoute>
              )
            },
            {
              name: "Generate Compensatory Off",
              link: "/generateCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <GenerateCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply Maternity Leave",
              link: "/applyMaternityLeaves",
              component: (
                <ProtectedRoute>
                  <ApplyMaternityLeaves />
                </ProtectedRoute>
              )
            },
            {
              name: "List Compensatory Off",
              link: "/listCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <ListCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Application Received",
              link: "/leaveApplicationReceived",
              component: (
                <ProtectedRoute>
                  <LeaveApplicationReceived />
                </ProtectedRoute>
              )
            },
            {
              name: "Compensatory Request Received",
              link: "/compensatoryRequestReceived",
              component: (
                <ProtectedRoute>
                  <CompensatoryRequestReceived />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Probation Period",
          Icon: AssignmentLateIcon,
          items: [
            {
              name: "Probation List",
              link: "/employeeProbationList",
              component: (
                <ProtectedRoute>
                  <EmployeeProbationList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Resignation Request",
          Icon: PendingActionsIcon,
          items: [
            {
              name: "Resignation Request List",
              link: "/Resignation_Request_List",
              component: (
                <ProtectedRoute>
                  <Resignation_Request_List />
                </ProtectedRoute>
              )
            },
            ...(JSON.parse(localStorage.getItem("userType")) === "Finance_Manager"
              ? [
                  {
                    name: "Finance Clearance List",
                    link: "/financeClearanceList",
                    component: (
                      <ProtectedRoute>
                        <FinanceClearanceList />
                      </ProtectedRoute>
                    )
                  }
                ]
              : [])
          ]
        },
        {
          name: "Reports",
          Icon: InsertChartOutlinedIcon,
          items: [
            {
              name: "Experience Report",
              link: "/experience_Reports",
              component: (
                <ProtectedRoute>
                  <Experience_Reports />
                </ProtectedRoute>
              )
            }
          ]
        },
        // {
        //   name: "Gallery",
        //   link: "/gallery",
        //   Icon: IconLibraryBooks,
        //   component: <Gallery />
        // },
        {
          name: "Settings",
          Icon: SettingsIcon,
          items: [
            {
              name: "Change Password",
              link: "/changeEmployeePassword",
              component: (
                <ProtectedRoute>
                  <ChangeEmployeePassword />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Logout",
          link: "/logout",
          Icon: LogoutIcon,
          component: (
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          )
        }
      ];
    } else if (JSON.parse(localStorage.getItem("userType")) == "IT_Admin_Manager") {
      appMenuItems = [
        {
          name: "Dashboard",
          link: "/dashboard",
          Icon: IconDashboard,
          component: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )
        },
        {
          name: "Asset Management",
          Icon: HardwareTwoToneIcon,
          items: [
            {
              name: "Issue Asset",
              link: "/assetList",
              component: (
                <ProtectedRoute>
                  <AssetList />
                </ProtectedRoute>
              )
            },
            {
              name: "Receive Asset",
              link: "/receiveAsset",
              component: (
                <ProtectedRoute>
                  <ReceiveAsset />
                </ProtectedRoute>
              )
            },
            {
              name: "Component",
              link: "/components",
              component: (
                <ProtectedRoute>
                  <AddComponent />
                </ProtectedRoute>
              )
            },
            {
              name: "New Asset",
              link: "/addAsset",
              component: (
                <ProtectedRoute>
                  <AddAsset />
                </ProtectedRoute>
              )
            },
            {
              name: "IT Helpdesk",
              link: "/it-helpdesk",
              component: (
                <ProtectedRoute>
                  <ITHelpdesk />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Employee",
          Icon: IconPeople,
          items: [
            {
              name: "View Details",
              link: "/profile",
              component: (
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              )
            },
            {
              name: "Update",
              link: "/employee",
              component: (
                <ProtectedRoute>
                  <Employee />
                </ProtectedRoute>
              )
            },
            {
              name: "Appraisal Form",
              link: "/evaluationpolicy",
              component: (
                <ProtectedRoute>
                  <Appraisal_Form />
                </ProtectedRoute>
              )
            },
            {
              name: "View Ratings",
              link: "/viewRatings",
              component: <ViewRatings />
            },
            {
              name: "Resignation",
              link: "/resignation",
              component: (
                <ProtectedRoute>
                  <Resignation />
                </ProtectedRoute>
              )
            },
            {
              name: "Policy Documents",
              link: "/policyDocuments",
              component: (
                <ProtectedRoute>
                  <PolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Referral Bonus",
              link: "/employeeReferralBonusDocument",
              component: (
                <ProtectedRoute>
                  <EmployeeReferralBonusDocument />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Performance Appraisal",
          Icon: BarChartIcon,
          items: [
            {
              name: "Add Technical Skills",
              link: "/add_technical_skills",
              component: (
                <ProtectedRoute>
                  <Add_technical_skills />
                </ProtectedRoute>
              )
            },
            {
              name: "List Technical Skills",
              link: "/list_technical_skills",
              component: (
                <ProtectedRoute>
                  <List_technical_skills />
                </ProtectedRoute>
              )
            },
            {
              name: "KRA Form Overview",
              link: "/kra_form_overview",
              component: (
                <ProtectedRoute>
                  <KRA_form_overview />
                </ProtectedRoute>
              )
            },
            {
              name: "KRA Status",
              link: "/kra_status",
              component: (
                <ProtectedRoute>
                  <KRA_status />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Performance Improvement",
          Icon: TrendingUpIcon,
          items: [
            {
              name: "List",
              link: "/performanceImprovementList",
              component: (
                <ProtectedRoute>
                  <PerformanceImprovementList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Leave Management",
          Icon: WorkOffIcon,
          items: [
            {
              name: "LMS Policy Document",
              link: "/lMSPolicyDocument",
              component: (
                <ProtectedRoute>
                  <LMSPolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply for Leave",
              link: "/applyLeave",
              component: (
                <ProtectedRoute>
                  <ApplyLeave />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Request List",
              link: "/leaveRequestList",
              component: (
                <ProtectedRoute>
                  <LeaveRequestList />
                </ProtectedRoute>
              )
            },
            {
              name: "Generate Compensatory Off",
              link: "/generateCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <GenerateCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply Maternity Leave",
              link: "/applyMaternityLeaves",
              component: (
                <ProtectedRoute>
                  <ApplyMaternityLeaves />
                </ProtectedRoute>
              )
            },
            {
              name: "List Compensatory Off",
              link: "/listCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <ListCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Application Received",
              link: "/leaveApplicationReceived",
              component: (
                <ProtectedRoute>
                  <LeaveApplicationReceived />
                </ProtectedRoute>
              )
            },
            {
              name: "Compensatory Request Received",
              link: "/compensatoryRequestReceived",
              component: (
                <ProtectedRoute>
                  <CompensatoryRequestReceived />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Probation Period",
          Icon: AssignmentLateIcon,
          items: [
            {
              name: "Probation List",
              link: "/employeeProbationList",
              component: (
                <ProtectedRoute>
                  <EmployeeProbationList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Resignation Request",
          Icon: PendingActionsIcon,
          items: [
            {
              name: "Resignation Request List",
              link: "/Resignation_Request_List",
              component: (
                <ProtectedRoute>
                  <Resignation_Request_List />
                </ProtectedRoute>
              )
            },
            {
              name: "IT Clearance List",
              link: "/itClearanceList",
              component: (
                <ProtectedRoute>
                  <ITClearanceList />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "Finance Clearance List",
            //   link: "/financeClearanceList",
            //   component: (
            //     <ProtectedRoute>
            //       <FinanceClearanceList />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "Administration Clearance List",
              link: "/administrationClearanceList",
              component: (
                <ProtectedRoute>
                  <AdministrationClearanceList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Reports",
          Icon: InsertChartOutlinedIcon,
          items: [
            {
              name: "Experience Report",
              link: "/experience_Reports",
              component: (
                <ProtectedRoute>
                  <Experience_Reports />
                </ProtectedRoute>
              )
            }
          ]
        },
        // {
        //   name: "Gallery",
        //   link: "/gallery",
        //   Icon: IconLibraryBooks,
        //   component: <Gallery />
        // },
        {
          name: "Settings",
          Icon: SettingsIcon,
          items: [
            {
              name: "Change Password",
              link: "/changeEmployeePassword",
              component: (
                <ProtectedRoute>
                  <ChangeEmployeePassword />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Logout",
          link: "/logout",
          Icon: LogoutIcon,
          component: (
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          )
        }
      ];
    } else if (JSON.parse(localStorage.getItem("userType")) == "IT_Admin_Employee") {
      appMenuItems = [
        {
          name: "Dashboard",
          link: "/dashboard",
          Icon: IconDashboard,
          component: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )
        },
        {
          name: "Asset Management",
          Icon: HardwareTwoToneIcon,
          items: [
            {
              name: "Issue Asset",
              link: "/assetList",
              component: (
                <ProtectedRoute>
                  <AssetList />
                </ProtectedRoute>
              )
            },
            {
              name: "Receive Asset",
              link: "/receiveAsset",
              component: (
                <ProtectedRoute>
                  <ReceiveAsset />
                </ProtectedRoute>
              )
            },
            {
              name: "Component",
              link: "/components",
              component: (
                <ProtectedRoute>
                  <AddComponent />
                </ProtectedRoute>
              )
            },
            {
              name: "New Asset",
              link: "/addAsset",
              component: (
                <ProtectedRoute>
                  <AddAsset />
                </ProtectedRoute>
              )
            },
            {
              name: "IT Helpdesk",
              link: "/it-helpdesk",
              component: (
                <ProtectedRoute>
                  <ITHelpdesk />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Employee",
          Icon: IconPeople,
          items: [
            {
              name: "View Details",
              link: "/profile",
              component: (
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              )
            },
            {
              name: "Update",
              link: "/employee",
              component: (
                <ProtectedRoute>
                  <Employee />
                </ProtectedRoute>
              )
            },
            {
              name: "Appraisal Form",
              link: "/evaluationpolicy",
              component: (
                <ProtectedRoute>
                  <Appraisal_Form />
                </ProtectedRoute>
              )
            },
            {
              name: "View Ratings",
              link: "/viewRatings",
              component: <ViewRatings />
            },
            {
              name: "Resignation",
              link: "/resignation",
              component: (
                <ProtectedRoute>
                  <Resignation />
                </ProtectedRoute>
              )
            },
            {
              name: "ITClearanceList",
              link: "/itClearanceList",
              component: (
                <ProtectedRoute>
                  <ITClearanceList />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "FinanceClearanceList",
            //   link: "/financeClearanceList",
            //   component: (
            //     <ProtectedRoute>
            //       <FinanceClearanceList />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "AdministrationClearanceList",
              link: "/administrationClearanceList",
              component: (
                <ProtectedRoute>
                  <AdministrationClearanceList />
                </ProtectedRoute>
              )
            },
            {
              name: "Policy Documents",
              link: "/policyDocuments",
              component: (
                <ProtectedRoute>
                  <PolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Referral Bonus",
              link: "/employeeReferralBonusDocument",
              component: (
                <ProtectedRoute>
                  <EmployeeReferralBonusDocument />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Leave Management",
          Icon: WorkOffIcon,
          items: [
            {
              name: "LMS Policy Document",
              link: "/lMSPolicyDocument",
              component: (
                <ProtectedRoute>
                  <LMSPolicyDocuments />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply for Leave",
              link: "/applyLeave",
              component: (
                <ProtectedRoute>
                  <ApplyLeave />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Request List",
              link: "/leaveRequestList",
              component: (
                <ProtectedRoute>
                  <LeaveRequestList />
                </ProtectedRoute>
              )
            },
            // ,
            // {
            //   name: "View Ratings",
            //   link: "/viewRatings",
            //   component: <ProtectedRoute><ViewRatings /></ProtectedRoute>,
            // }
            {
              name: "Generate Compensatory Off",
              link: "/generateCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <GenerateCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "Apply Maternity Leaves",
              link: "/applyMaternityLeaves",
              component: (
                <ProtectedRoute>
                  <ApplyMaternityLeaves />
                </ProtectedRoute>
              )
            },
            {
              name: "List Compensatory Off",
              link: "/listCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <ListCompensatoryOff />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Gallery",
          link: "/gallery",
          Icon: ImageIcon,
          component: (
            <ProtectedRoute>
              <Gallery />
            </ProtectedRoute>
          )
        },
        {
          name: "Settings",
          Icon: SettingsIcon,
          items: [
            {
              name: "Change Password",
              link: "/changeEmployeePassword",
              component: (
                <ProtectedRoute>
                  <ChangeEmployeePassword />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Logout",
          link: "/logout",
          Icon: LogoutIcon,
          component: (
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          )
        }
      ];
    } else {
      appMenuItems = [
        {
          name: "Dashboard",
          link: "/dashboard",
          Icon: IconDashboard,
          component: (
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          )
        },
        {
          name: "Offer Letter",
          Icon: DescriptionIcon,
          items: [
            {
              name: "Create New",
              link: "/offer",
              component: (
                <ProtectedRoute>
                  <CreateNewOffer />
                </ProtectedRoute>
              )
            },
            {
              name: "List",
              link: "/Offer_List",
              component: (
                <ProtectedRoute>
                  <OfferList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Employee",
          Icon: IconPeople,
          items: [
            {
              name: "List",
              link: "/Employee_List",
              component: (
                <ProtectedRoute>
                  <EmployeeList />
                </ProtectedRoute>
              )
            }
          ]
        },
        // {
        //   name: "Appointment Letter",
        //   Icon: IconPeople,
        //   items: [
        //     {
        //        name: "List",
        //       link: "/AppointmentList",
        //       component: <ProtectedRoute><AppointmentList /></ProtectedRoute>
        //     }
        //   ]
        // },
        // {
        //   name: "Probation Reports",
        //   Icon: IconPeople,
        //   items: [
        //     {
        //       name: "Employee Probation Reports",
        //       link: "/employeeProbationReports",
        //       component: <ProtectedRoute><AdminProbationReport /></ProtectedRoute>
        //     }
        //   ]
        // },
        {
          name: "Performance Improvement",
          Icon: TrendingUpIcon,
          items: [
            {
              name: "Add",
              link: "/createPerformanceImprovement",
              component: (
                <ProtectedRoute>
                  <CreatePerformanceImprovement />
                </ProtectedRoute>
              )
            },
            {
              name: "List",
              link: "/performanceImprovementList",
              component: (
                <ProtectedRoute>
                  <PerformanceImprovementList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Performance Evaluation",
          Icon: BarChartIcon,
          items: [
            {
              name: "Open KRA Window",
              link: "/openKRAWindow",
              component: (
                <ProtectedRoute>
                  <OpenKRAWindow />
                </ProtectedRoute>
              )
            },
            {
              name: "Edit KRA Window",
              link: "/editKRA",
              component: (
                <ProtectedRoute>
                  <ExtendKra />
                </ProtectedRoute>
              )
            },
            {
              name: "KRA Form Overview",
              link: "/kraFormOverview",
              component: (
                <ProtectedRoute>
                  <KraFormOverview />
                </ProtectedRoute>
              )
            },
            {
              name: "Add Skills",
              link: "/addSkills",
              component: (
                <ProtectedRoute>
                  <AddSkills />
                </ProtectedRoute>
              )
            },
            {
              name: "List Skills",
              link: "/listSkills",
              component: (
                <ProtectedRoute>
                  <ListSkills />
                </ProtectedRoute>
              )
            },
            {
              name: "Status Report",
              link: "/statusReport",
              component: (
                <ProtectedRoute>
                  <StatusReport />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Leave Management",
          Icon: WorkOffIcon,
          items: [
            {
              name: "Apply for Leave",
              link: "/adminApplyLeave",
              component: (
                <ProtectedRoute>
                  <AdminApplyLeave />
                </ProtectedRoute>
              )
            },
            {
              name: "Leave Request",
              link: "/adminLeaveRequest",
              component: (
                <ProtectedRoute>
                  <AdminLeaveRequest />
                </ProtectedRoute>
              )
            },
            {
              name: "Assign Compensatory Off",
              link: "/assignCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <AssignCompensatoryOff />
                </ProtectedRoute>
              )
            },
            {
              name: "List Compensatory Off",
              link: "/AdminListCompensatoryOff",
              component: (
                <ProtectedRoute>
                  <AdminListCompensatoryOff />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Resignation Request",
          Icon: PendingActionsIcon,
          items: [
            {
              name: "Resignation Request List",
              link: "/ResignationRequestList",
              component: (
                <ProtectedRoute>
                  <ResignationRequestList />
                </ProtectedRoute>
              )
            },
            {
              name: "HR Clearance List",
              link: "/hrClearanceList",
              component: (
                <ProtectedRoute>
                  <HRClearanceList />
                </ProtectedRoute>
              )
            },
            {
              name: "Exit Interview List",
              link: "/exitInterviewList",
              component: (
                <ProtectedRoute>
                  <ExitInterviewList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Client / Project",
          Icon: FolderSharedIcon,
          items: [
            {
              name: "Add Client",
              link: "/addClient",
              component: <AddClient />
            },
            {
              name: "Client List",
              link: "/clientList",
              component: (
                <ProtectedRoute>
                  <ClientList />
                </ProtectedRoute>
              )
            },
            {
              name: "Add Project",
              link: "/addProject",
              component: (
                <ProtectedRoute>
                  <AddProject />
                </ProtectedRoute>
              )
            },
            {
              name: "Project List",
              link: "/projectList",
              component: (
                <ProtectedRoute>
                  <ProjectList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Reports",
          Icon: InsertChartOutlinedIcon,
          items: [
            {
              name: "Joining Report",
              link: "/JoiningReport",
              component: (
                <ProtectedRoute>
                  <AdminJoiningReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Performance Evaluation Report",
              link: "/performanceAppraisalReport",
              component: (
                <ProtectedRoute>
                  <PerformanceAppraisalReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Reporting List",
              link: "/reportingList",
              component: (
                <ProtectedRoute>
                  <ReportingList />
                </ProtectedRoute>
              )
            },
            {
              name: "Balance Leave Report",
              link: "/balanceLeaveReport",
              component: (
                <ProtectedRoute>
                  <BalanceLeaveReport />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "Consumed Leave Report",
            //   link: "/ConsumedLeaveReport",
            //   component: <ProtectedRoute><ConsumedLeaveReport /></ProtectedRoute>,
            // },
            {
              name: "LWP Report",
              link: "/lwpReport",
              component: (
                <ProtectedRoute>
                  <LWPLeaveReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Biometric Leave Report",
              link: "/biometricLeaveReport",
              component: (
                <ProtectedRoute>
                  <BiometricLeaveReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Experience Report",
              link: "/experienceReport",
              component: (
                <ProtectedRoute>
                  <ExperienceReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Billing Report",
              link: "/employeeBillingReport",
              component: (
                <ProtectedRoute>
                  <EmployeeBillingReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Technology Report",
              link: "/technologyReport",
              component: (
                <ProtectedRoute>
                  <TechnologyReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Assign Project Report",
              link: "/assignprojectReport",
              component: (
                <ProtectedRoute>
                  <ProjectReport />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "Defaulter List (PA)",
            //   link: "/defaulterList",
            //   component: (
            //     <ProtectedRoute>
            //       <DefaulterList />
            //     </ProtectedRoute>
            //   )
            // },
            // {
            //   name: "Temp_biom_data Report",
            //   link: "/temp_biom_data",
            //   component: (
            //     <ProtectedRoute>
            //       <Temp_biom_dataReport />
            //     </ProtectedRoute>
            //   )
            // },
            // {
            //   name: "Employee Attendance Report",
            //   link: "/employeeAttendanceReport",
            //   component: (
            //     <ProtectedRoute>
            //       <EmployeeAttendanceeReport />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "Employee Roster Report",
              link: "/employeeRosterReport",
              component: (
                <ProtectedRoute>
                  <EmployeeRosterReport />
                </ProtectedRoute>
              )
            },
            {
              name: "Employee Probation Reports",
              link: "/employeeProbationReports",
              component: (
                <ProtectedRoute>
                  <AdminProbationReport />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Job Vacancy",
          Icon: WorkIcon,
          items: [
            {
              name: "Add",
              link: "/addJobVacancy",
              component: (
                <ProtectedRoute>
                  <AddJobVacancy />
                </ProtectedRoute>
              )
            },
            {
              name: "List",
              link: "/JobVacancylist",
              component: (
                <ProtectedRoute>
                  <JobVacancyList />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Youtube Links",
          Icon: OndemandVideoIcon,
          items: [
            {
              name: "Add",
              link: "/addYoutubeLinks",
              component: (
                <ProtectedRoute>
                  <AddYoutubeLinks />
                </ProtectedRoute>
              )
            },
            {
              name: "List",
              link: "/youtubeLinksList",
              component: (
                <ProtectedRoute>
                  <YoutubeLinksList />
                </ProtectedRoute>
              )
            }
          ]
        },
        // {
        //   name: "Diwali Voucher",
        //   Icon: CardGiftcardIcon,
        //   items: [
        //     {
        //       name: "Voucher Window",
        //       link: "/voucherWindow",
        //       component: (
        //         <ProtectedRoute>
        //           <VoucherWindow />
        //         </ProtectedRoute>
        //       )
        //     },
        //     {
        //       name: "Upload Vouchers",
        //       link: "/uploadVouchers",
        //       component: (
        //         <ProtectedRoute>
        //           <UploadVouchers />
        //         </ProtectedRoute>
        //       )
        //     }
        //   ]
        // },
        {
          name: "Settings",
          Icon: SettingsIcon,
          items: [
            {
              name: "Admin Change Password",
              link: "/adminChangePassword",
              component: (
                <ProtectedRoute>
                  <AdminChangePassword />
                </ProtectedRoute>
              )
            },
            {
              name: "Default Values",
              link: "/defaultValues",
              component: (
                <ProtectedRoute>
                  <DefaultValues />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "Process Attendance Data",
            //   link: "/processAttendance",
            //   component: (
            //     <ProtectedRoute>
            //       <ProcessAttendanceData />
            //     </ProtectedRoute>
            //   )
            // },
            {
              name: "Birthday Template Upload",
              link: "/birthdayTemplate",
              component: (
                <ProtectedRoute>
                  <BirthdayTemplateUpload />
                </ProtectedRoute>
              )
            },
            // {
            //   name: "Biometric File Upload",
            //   link: "/biometricFile",
            //   component: <ProtectedRoute><BiometricFileUpload /></ProtectedRoute>,
            // },
            {
              name: "Event",
              link: "/event",
              component: (
                <ProtectedRoute>
                  <Event />
                </ProtectedRoute>
              )
            },
            {
              name: "Admin Permissions",
              link: "/adminPermissions",
              component: (
                <ProtectedRoute>
                  <AdminPermissions />
                </ProtectedRoute>
              )
            },
            {
              name: "Set Permissions",
              link: "/EditPermissions",
              component: (
                <ProtectedRoute>
                  <SetPermissions />
                </ProtectedRoute>
              )
            },
            {
              name: "Cron Job Links",
              link: "/cron-job-links",
              component: (
                <ProtectedRoute>
                  <CronJobLinks />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          name: "Logout",
          link: "/logout",
          Icon: LogoutIcon,
          component: (
            <ProtectedRoute>
              <Logout />
            </ProtectedRoute>
          )
        }
      ];
    }

    console.log("modifiedArray", modifiedArray);
  }

  const [controller] = useMaterialUIController();
  const {miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor} = controller;
  const [open, setOpen] = React.useState(true);
  let navigate = useNavigate();
  const classes = useStyles();

  return (
    <MDBox
      style={{margin: "0 0 0 0", fontFamily: "Prox"}}
      {...rest}
      sx={theme => ({
        ...collapseItem(theme, {
          active,
          transparentSidenav,
          whiteSidenav,
          darkMode,
          sidenavColor
        }),
        backgroundColor: "transparent !important",
        "&:hover": {
          backgroundColor: "transparent !important"
        }
      })}
    >
      <List component="div" className={classes.appMenu} disablePadding>
        {appMenuItems.map((item, index) => (
          <AppMenuItem active {...item} key={index} openItem={openItem} setOpenItem={setOpenItem} />
        ))}
      </List>
    </MDBox>
  );
};

const drawerWidth = 200;

const useStyles = makeStyles(theme =>
  createStyles({
    appMenu: {
      width: "100%"
    },
    navList: {
      width: drawerWidth
    },
    menuItem: {
      width: drawerWidth
    },
    menuItemIcon: {
      color: "#97c05c",
      width: "35px !important"
    }
  })
);

AppMenu.PropTypes = {
  item: PropTypes.string.isRequired,
  collapse: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  name: PropTypes.string,
  key: PropTypes.string,
  active: PropTypes.string,
  links: PropTypes.string
};
export default AppMenu;
